import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  sqConfirmationDetails: {}
};

export const sqConfirmationLetter = createSlice({
  name: 'sqConfirmationLetter',
  initialState,
  reducers: {
    setSQCLDetails: (state, action: PayloadAction<any>) => {
      state.sqConfirmationDetails = action.payload;
    }
  }
});

export const { setSQCLDetails } = sqConfirmationLetter.actions;
